import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const inputDefaultVariants = {}
const inputCompoundVariants = []

const inputSlotNames = [
  [
    "root",
    "input__root"
  ],
  [
    "label",
    "input__label"
  ],
  [
    "focusedLabel",
    "input__focusedLabel"
  ],
  [
    "filledLabel",
    "input__filledLabel"
  ],
  [
    "input",
    "input__input"
  ],
  [
    "errorLabel",
    "input__errorLabel"
  ],
  [
    "focusedErrorLabel",
    "input__focusedErrorLabel"
  ],
  [
    "filledErrorLabel",
    "input__filledErrorLabel"
  ],
  [
    "errorInput",
    "input__errorInput"
  ]
]
const inputSlotFns = /* @__PURE__ */ inputSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, inputDefaultVariants, getSlotCompoundVariant(inputCompoundVariants, slotName))])

const inputFn = memo((props = {}) => {
  return Object.fromEntries(inputSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const inputVariantKeys = []
const getVariantProps = (variants) => ({ ...inputDefaultVariants, ...compact(variants) })

export const input = /* @__PURE__ */ Object.assign(inputFn, {
  __recipe__: false,
  __name__: 'input',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: inputVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, inputVariantKeys)
  },
  getVariantProps
})